import { render, staticRenderFns } from "./ServiceToOrganization.vue?vue&type=template&id=2b88815b&scoped=true&"
import script from "./ServiceToOrganization.vue?vue&type=script&lang=js&"
export * from "./ServiceToOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88815b",
  null
  
)

export default component.exports